import { createContext, ReactElement, ReactNode, useContext, useMemo } from 'react'

import { RecurringInvoice } from '@features/recurringInvoices/types/recurringInvoice'

import { useFetchRecurringInvoice } from '../hooks/useFetchRecurringInvoice'

interface ContextState {
  isLoading: boolean
  recurringInvoice?: RecurringInvoice
  recurringInvoiceId: string
}

const RecurringInvoiceContext = createContext<ContextState | undefined>(undefined)

interface RecurringInvoiceContextProps {
  children?: ReactNode
  recurringInvoiceId: string
}

export const RecurringInvoiceContextProvider = ({
  recurringInvoiceId,
  children,
}: RecurringInvoiceContextProps): ReactElement => {
  const { recurringInvoice, isLoading } = useFetchRecurringInvoice(recurringInvoiceId)

  const contextValue = useMemo(
    () => ({
      isLoading,
      recurringInvoice,
      recurringInvoiceId,
    }),
    [isLoading, recurringInvoice, recurringInvoiceId],
  )

  return <RecurringInvoiceContext.Provider value={contextValue}>{children}</RecurringInvoiceContext.Provider>
}

export const useRecurringInvoice = () => {
  const context = useContext(RecurringInvoiceContext)

  if (!context) {
    throw new Error('RecurringInvoiceContextProvider is missing in the module!')
  }

  return context
}
